import type { ThemeChoice } from "./store.ts";

/** The page background in each scheme (index.css `--background`). The browser/OS chrome is tinted to match it. */
export const THEME_COLORS = { light: "#f5f8fd", dark: "#0b121f" } as const;

/** The colour for a `<meta name="theme-color" media="…">` tag, given the player's explicit choice (or "system"). */
export function themeColorFor(choice: ThemeChoice, media: string | null): string {
  if (choice !== "system") return THEME_COLORS[choice];
  return media?.includes("dark") ? THEME_COLORS.dark : THEME_COLORS.light;
}

/**
 * index.html carries one tag per scheme, so first paint is right with no script. When the player overrides the OS
 * (the sun/moon button), point both tags at their choice; on "system", put each back. Without this an installed app
 * on a dark phone would keep a light status bar over a night-mode game.
 */
export function syncThemeColor(choice: ThemeChoice): void {
  for (const meta of document.querySelectorAll<HTMLMetaElement>('meta[name="theme-color"]')) meta.content = themeColorFor(choice, meta.getAttribute("media"));
}
